import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Logo from '../img/logo.svg';


export class Header extends Component {
  state = {
    show: false,
    class: "",
    text: '+'
  }

  componentWillMount() {
    if(window.innerWidth < 992) {
      this.setState({
        class: "closed"
      })
    } else {
      this.setState({
        class: "opened"
      })
    }
  }

  handleToggle() {
    if (window.innerWidth < 992) {
      this.setState({
        show: !this.state.show
      });
      if(!this.state.show) {
        this.setState({
          class: "open",
          text: '-'
        });
      } else {
        this.setState({
          class: "closed",
          text: '+'
        });
      }
    }
  }

  renderHelper() {
      return(
        <nav onClick={() => this.handleToggle()} className={this.state.class}>
          <div className="container-middle justify-center">
            <Link to='/horfex'><p className="float">Horfex</p></Link>
            <Link to='/philosophie'><p className="float">Philosophie</p></Link>
            <Link to='/galerie/einfahrt'><p className="float">Galerie</p></Link>
            <Link to='/team'><p className="float">Team</p></Link>
            <Link to='/blog'><p className="float">Blog</p></Link>
            <Link to='/kontakt/all'><p className="float">Kontakt</p></Link>
          </div>
        </nav>
      );
    }


  render() {
    return (
      <div className="">
        <header className=" fullWidth">
          <Link to="/"><img alt-text="logo" className="logo" src={Logo} /></Link>
          <button className="" onClick={() => this.handleToggle()}>{this.state.text}</button>
        </header>
        <div>
          {this.renderHelper()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header.js